import {AuthRepository} from '../repositories/AuthRepository';
import {User, UserCredentials} from '../entities/User';

export class LoginUseCase {
  constructor(private readonly authRepository: AuthRepository) {}

  async execute(credentials: UserCredentials): Promise<User> {
    // Validación mínima: solo verificar que el email tenga formato básico
    // Aceptar cualquier contraseña
    if (!credentials.email || !credentials.email.trim()) {
      throw new Error('El email es requerido');
    }

    if (!credentials.password || !credentials.password.trim()) {
      throw new Error('La contraseña es requerida');
    }

    // Validación opcional de formato de email (puede ser cualquier formato)
    // Se mantiene solo para evitar emails completamente vacíos o inválidos
    if (!this.isValidEmailFormat(credentials.email.trim())) {
      throw new Error('Formato de email inválido');
    }

    return await this.authRepository.login(credentials);
  }

  private isValidEmailFormat(email: string): boolean {
    // Validación muy básica: debe contener al menos un @ y un punto después del @
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}

